const FOOT_LINKS = [
  { title: "归档", items: ["本周汇总", "近期盘点", "本月黑料合集", "热度总榜"] },
  { title: "题材", items: ["圈内", "商界", "综艺", "网红·直播"] },
  { title: "服务", items: ["投稿线索", "联系我们", "版权投诉", "加入我们"] },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-8">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center font-heading text-lg font-black text-background-50">料</span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-[20px] font-black text-foreground-950">最新黑料</span>
                <span className="text-[11px] text-foreground-500 mt-0.5">WEEKLY DOSSIER · 每周更一份</span>
              </span>
            </a>
            <p className="mt-4 text-[13.5px] leading-relaxed text-foreground-600 max-w-xs">
              一个专注做「事件索引」的轻杂志站：本周汇总、近期盘点与本月黑料新近合集，都整理成档、按时间线可查。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-mail-fill", "ri-rss-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="站点入口"
                  className="w-9 h-9 rounded-md bg-background-50 border border-background-300 text-foreground-600 hover:text-background-50 hover:bg-primary-500 hover:border-primary-500 flex items-center justify-center transition-colors"
                >
                  <i className={`${ic} w-4 h-4 flex items-center justify-center`} />
                </a>
              ))}
            </div>
          </div>

          {FOOT_LINKS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-[15px] font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-3 space-y-2.5">
                {col.items.map((it) => (
                  <li key={it}>
                    <a href="#top" className="text-[13.5px] text-foreground-600 hover:text-primary-600 transition-colors">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[12.5px] text-foreground-500">
            © 2026 最新黑料 · 本站内容均为公开网络讯息的事件索引与盘点，仅供信息梳理参考，不代表站方立场。
          </p>
          <p className="text-[12px] text-foreground-400 whitespace-nowrap">题材分栏 · 时间线补课 · 近7日更新 48 条</p>
        </div>
      </div>
    </footer>
  );
}